__webpack_require__.p = "https://connected-products-mfe-grabthar.digital.vpsvc.com/";